"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfTuberculosisScreeningSymptomDto = instanceOfTuberculosisScreeningSymptomDto;
exports.TuberculosisScreeningSymptomDtoFromJSON = TuberculosisScreeningSymptomDtoFromJSON;
exports.TuberculosisScreeningSymptomDtoFromJSONTyped = TuberculosisScreeningSymptomDtoFromJSONTyped;
exports.TuberculosisScreeningSymptomDtoToJSON = TuberculosisScreeningSymptomDtoToJSON;
exports.TuberculosisScreeningSymptomDtoToJSONTyped = TuberculosisScreeningSymptomDtoToJSONTyped;
/**
 * Check if a given object implements the TuberculosisScreeningSymptomDto interface.
 */
function instanceOfTuberculosisScreeningSymptomDto(value) {
    if (!('code' in value) || value['code'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    return true;
}
function TuberculosisScreeningSymptomDtoFromJSON(json) {
    return TuberculosisScreeningSymptomDtoFromJSONTyped(json, false);
}
function TuberculosisScreeningSymptomDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'code': json['code'],
        'name': json['name'],
        'answer': json['answer'] == null ? undefined : json['answer'],
    };
}
function TuberculosisScreeningSymptomDtoToJSON(json) {
    return TuberculosisScreeningSymptomDtoToJSONTyped(json, false);
}
function TuberculosisScreeningSymptomDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'code': value['code'],
        'name': value['name'],
        'answer': value['answer'],
    };
}
//# sourceMappingURL=TuberculosisScreeningSymptomDto.js.map